<ng-container *ngComponentOutlet="LoaderComponent">
</ng-container>
<div mat-dialog-title style="position: relative;">
    <p style="font-weight: bold; background-color: #efefef; color: #c89d07;padding: 8px;margin-top: -8px;
    margin-left: -24px;margin-right: -24px;">
        {{title}}
    </p>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close"
       (click)="onNoClick()" style="color: black; top: 0px;left: 945px;position: absolute;">
        <span aria-hidden="true" class="">&times;</span>
    </button>
</div>
<div mat-dialog-content class="dialog-content">
    <form [formGroup]="brokerForm">
        <div class="row">
            <div class="col-md-4 flexRows" *ngIf="data">
                <div class="broker-img-container">
                    <img *ngIf="brokerImage == ''" class="broker-img" src="https://via.placeholder.com/150" alt="">
                    <img *ngIf="brokerImage" class="broker-img" [src]="brokerImage" alt="">
                </div>
                <div class="btn-holder">
                    <button *ngIf="brokerImage == ''" class="action_icon" (click)="browsePhoto(1)">
                        <img [src]="profileIcon" alt="" data-toggle="tooltip" title="Upload photo">
                    </button>
                    <button *ngIf="brokerImage" class="action_icon" (click)="deleteImg(1)">
                        <img [src]="deleteIcon" alt="" data-toggle="tooltip" title="Delete">
                    </button>  
                </div>
            </div>
            <div class="col-md-4 flexRows">
                <div class="row inputBox customMultiSelect" [ngStyle]="{'margin-top': data ? '30px' : ''}">
                    <div class="col-md-12" style="padding-left: 0;">
                        <p>Name</p>
                    </div>
                    <div class="col-md-12" style="padding-left: 0;">
                        <input type="text" class="form-control" placeholder="Enter Name" formControlName="name">
                        <div class="error-msg" *ngIf="brokerForm.controls.name.errors && brokerForm.controls.name.errors.required">
                            Required Name
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4 flexRows">
                <div class="row inputBox customMultiSelect" [ngStyle]="{'margin-top': data ? '30px' : ''}">
                    <div class="col-md-12" style="padding-left: 0;">
                        <p>Email</p>
                    </div>
                    <div class="col-md-12" style="padding-left: 0;">
                        <input type="email" class="form-control" placeholder="Enter Email" formControlName="email">
                        <div class="error-msg" *ngIf="brokerForm.controls.email.errors && brokerForm.controls.email.errors.required">
                            Required Email
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4 flexRows">
                <div class="row inputBox customMultiSelect">
                    <div class="col-md-12" style="padding-left: 0;">
                        <p>Mobile</p>
                    </div>
                    <div class="col-md-12" style="padding-left: 0;">
                        <input type="tel" class="form-control" (keypress)="omit_specialChar_and_char($event)" minlength="10" maxlength="10" placeholder="Enter Mobile" formControlName="mobileNumber">
                        <div class="error-msg" *ngIf="brokerForm.controls.mobileNumber.errors && brokerForm.controls.mobileNumber.errors.required">
                            Required Mobile
                        </div>
                        <!-- <div class="error-msg" *ngIf="brokerForm.controls.mobileNumber.errors.minlength">
                            Valid Mobile
                        </div> -->
                    </div>
                </div>
            </div>
            <!-- <div class="col-md-3 flexRows">
                <div class="row inputBox customMultiSelect">
                    <div class="col-md-12" style="padding-left: 0;">
                        <p>Settlement Commission</p>
                    </div>
                    <div class="col-md-12" style="padding-left: 0;">
                        <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="settlementDropDownSettings"
                            class="ka-em-multiselect" [data]="settlementCommission" formControlName="settlementCommission">
                        </ng-multiselect-dropdown>
                    </div>
                </div>
            </div> -->
            <div class="col-md-4 flexRows">
                <div class="row inputBox customMultiSelect">
                    <div class="col-md-12" style="padding-left: 0;">
                        <p>Registration Commission</p>
                    </div>
                    <div class="col-md-12" style="padding-left: 0;">
                        <ng-multiselect-dropdown [placeholder]="'Select Registration Commission'" [settings]="settlementDropDownSettings"
                            class="ka-em-multiselect" [data]="registrationCommission" formControlName="registrationCommission">
                        </ng-multiselect-dropdown>
                    </div>
                </div>
            </div>
            <div class="col-md-5 flexRows">
                <div class="row inputBox customMultiSelect">
                    <div class="col-md-12" style="padding-left: 0;">
                        <p>Landline</p>
                    </div>
                    <div class="col-md-12 row" style="padding-left: 0;">
                        <div class="col-md-4">
                            <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="countryDropdownSettings"
                                class="ka-em-multiselect" [data]="countryArray" formControlName="countryCode">
                            </ng-multiselect-dropdown>
                        </div>
                        <div class="col-md-4">
                            <input type="text" formControlName="areaCode" id="fblandLine4" mdbInput
                            class="form-control" placeholder="" maxlength="4" size="4"
                            (keypress)="omit_specialChar_and_char($event)">
                        </div>
                        <div class="col-md-4">
                            <input type="text" formControlName="landlineNumber" id="fblandLine8" mdbInput
                                class="form-control" placeholder="" maxlength="8" size="8"
                                (keypress)="omit_specialChar_and_char($event)">
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 flexRows" *ngIf="data">
                <div class="row inputBox customMultiSelect">
                    <div class="col-md-12" style="padding-left: 0;">
                        <p>Attach file</p>
                    </div>
                    <div class="col-md-12 row" style="padding-left: 0;">
                        <div class="col-md-10 word-wrap" *ngIf="brokerFile">
                            <a [href]="brokerFile" target="_blank">{{brokerFile}}</a>
                        </div>
                        <div class="col-md-2">
                            <button *ngIf="brokerFile === ''" class="action_icon" (click)="browsePhoto(2)">
                                <i class="fa fa-paperclip"></i>
                            </button>
                            <button *ngIf="brokerFile" class="action_icon" (click)="deleteImg(2)">
                                <img [src]="deleteIcon" alt="" data-toggle="tooltip" title="Delete">
                            </button>  
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 flexRows">
                <div class="row inputBox customMultiSelect">
                    <div class="col-md-12" style="padding-left: 0;">
                        <p>Contact Address</p>
                    </div>
                    <div class="col-md-12" style="padding-left: 0;">
                        <textarea class="form-control" placeholder="Contact Address" formControlName="contactAddress" cols="10" rows="5"></textarea>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
<div mat-dialog-actions align="end">
    <div>
        <button mat-button (click)="onNoClick()">Cancel</button>
        <button [hidden]="data" mat-button class="submit" [disabled]="!brokerForm.valid" (click)="createBroker()">Submit</button>
        <button *ngIf="data" mat-button class="submit" [disabled]="!brokerForm.valid" (click)="updateBroker()">Update</button>
    </div>
</div>

<div mdbModal #basicModal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeBasicModal()">
                <span aria-hidden="true" class="">&times;</span>
            </button>
            <div class="container">
                <div class="row" style="text-align: center;">

                    <div
                        class="ka-upload-section col-12 col-sm-12 col-xs-12 col-md-12 col-lg-12 col-xl-12  ka-reg-small-dashed-card">
                        <div class="ka-dashed-div" appDnd (fileDropped)="onFileDropped($event)">
                            <br>

                            <img src="../../../assets/img/register/upload_photos_ic.png" alt=""
                                style="height: 70px;">

                                <div class="row" *ngIf="isUploading && tempUrlImg">
                                    <div class="col-md-12">
                                        <div class="imgWidth">
                                            <img src="{{tempUrlImg}}" alt=""
                                                style="height:100px;width: 400px;max-width: 100%;">
                                        </div>
    
                                        <mdb-icon class="ka-delete" fas icon="times" (click)="deleteFile(1)"
                                            style="z-index: 99999;">
                                        </mdb-icon>
                                    </div>
                                </div>
                                <div class="row" *ngIf="!isUploading && tempUrlImg">
                                    <div class="col-md-12">
                                        <div class="imgWidth">
                                            <img src="{{tempUrlImg}}" alt=""
                                                style="height:100px;width: 400px;max-width: 100%;">
                                        </div>
    
                                        <mdb-icon class="ka-delete" fas icon="times" (click)="deleteFile(1)"
                                            style="z-index: 99999;">
                                        </mdb-icon>
                                    </div>
                                </div>

                        </div>



                        <p class="upload-sub-text">or</p>
                        <a mdbBtn class=" ka-white-button ka-outline-button mt-0 mb-5" style="width: 152px;"
                            (click)=" browseFiles()">Browse

                            <input *ngIf="fileType === 2" type="file" #fileDropRef id="fileDropRef"
                                (change)="fileBrowseHandler($event.target.files)"
                                accept="image/jpeg,image/jpg,application/pdf,application/doc,application/docx" />
                            <input *ngIf="fileType === 1" type="file" #fileDropRef id="fileDropRef"
                                (change)="fileBrowseHandler($event.target.files)"
                                accept="image/jpeg,image/jpg, image/gif" />    

                        </a>

                    </div>
                    <div style="text-align: center; width: 100%;">
                        <button mdbBtn
                            class="ka-white-button tButton ka-btn-primary btn-success btn mb-4 mt-2 ka-normalButton-height marginleft"
                            style="width:35%; text-align: center;" type="submit"
                            (click)="uploadProfileImages()">Upload
                            Photos
                        </button>
                    </div>

                </div>

            </div>
        </div>
    </div>
</div>


<div mdbModal #successModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
aria-labelledby="myBasicModalLabel" aria-hidden="true"
[config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
<div class="modal-dialog modal-md modal-dialog-centered" role="document">

  <div class="modal-content">
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="successModal.hide()">
      <span aria-hidden="true" class="">&times;</span>
    </button>
    <div class="row text-left">

      <!--Grid column-->
      <div class="col-md-12 rmSectionPopup">
        <div class="row p-2 m-2">

          <div class="col-md-12 rmDetailsSectionPopup" style="text-align: center;">
            <!-- <img src="../../../../assets/img/dashboard/rm_temp.PNG" /> -->
            <p class="mt-2 p-0">{{responseMessage}} </p>

            <div class="action-buttons">
              <button mdbBtn class="ka-white-button  tButton ka-btn-primary btn-success btn mb-3 mt-2"
                mdbWavesEffect type="submit" (click)="successModal.hide()">ok
              </button>



            </div>

          </div>
        </div>

      </div>

      <!--Grid column-->



    </div>
  </div>
</div>
</div>